/// <reference path="../setup/_references.ts" />
module onvio.nav.staffNav {
    'use strict';

    export class StaffNavController {
        public showClientDashboard = false;
        public showDueDates = false;
        public showBRMessenger = false;
        public showBRDepartments = false;
        public showFirmDashboard = false;
        public showImports = false;
        public showMigrations = false;
        public showOldMigrationsLink = false;
        public showTimeAndExpenses = false;
        public showBilling = false;
        public showReceiptsAndAdjustments = false;
        public hideFirmReportsIAC = false;
        public hideNewActivityCategory = false;
        public hideNewActivity = false;
        public reportsFirmManagementFRP = false;
        public showFirmReports = false;
        public showReportEmployee = true;
        public setupPermissions = [
            'OnvioSetup.Setup',
            'BRCustos.AllPermissions',
            'OnvioSetup.Clients',
            'OnvioSetup.Staff',
            'OnvioSetup.Contacts',
            'OnvioSetup.ContactCategories',
            'BRCustos.AllPermissions',
            'OnvioSetup.Firm',
            'OnvioSetup.SecurityGroups',
            'OnvioDrive.Templates',
            'OnvioSetup.Offices',
            'OnvioSetup.Departments',
            'OnvioBR.EnableBRDepartments',
            'TimeAndBilling.StandardText',
            'OnvioSetup.Activities',
            'OnvioSetup.ActivityCategories',
            'OnvioSetup.EngagementTemplates',
            'OnvioSetup.EngagementCategories',
            'OnvioSetup.StaffLevels',
            'OnvioSetup.StaffRateDescriptions',
            'OnvioSetup.FixedFeeTemplates',
            'OnvioSetup.FormatTemplates',
            'OnvioSetup.LateFeeTemplates',
            'OnvioSetup.BankAccounts',
            'OnvioSetup.TaxRates',
            'OnvioSetup.TaxGroups',
            'OnvioSetup.ClientNotifications',
            'OnvioSetup.Appearances',
            'OnvioSetup.OnvioSecurity',
            'OnvioSetup.Migrations',
            'OnvioSetup.MigrateData',

        ];

        public brMessengerURL = '';
        public hasLicenseForBrazilStaffPermissionGroup = false;

        static $inject = [
            '$q',
            'bmLicense',
            'bmAccess',
            'bmPermission',
            'bmEnvironment'
        ];
        constructor(
            $q: ng.IQService,
            bmLicense: any,
            bmAccess: any,
            bmPermission: bluemoon.components.IBmPermissionService,
            bmEnvironment: any
        ) {
            const clientDashPromises = [];
            clientDashPromises.push(bmLicense.has('Onvio.ClientDashboard'));
            clientDashPromises.push(bmPermission.has('Onvio.ClientDashboard'));
            clientDashPromises.push(bmAccess.has('Client_Dashboard'));
            clientDashPromises.push(bmLicense.not('Application.OnvioDocumentsBasic'));
            clientDashPromises.push(bmPermission.not('GFR.ClientFlow'));

            const firmDashPromises = [];
            firmDashPromises.push(bmLicense.has('Onvio.FirmDashboard'));
            firmDashPromises.push(bmPermission.has('Onvio.FirmDashboard'));
            firmDashPromises.push(bmAccess.has('Firm_Dashboard'));
            firmDashPromises.push(bmLicense.not('Application.OnvioDocumentsBasic'));
            firmDashPromises.push(bmPermission.not('GFR.ClientFlow'));

            const dueDatesPromises = [];
            dueDatesPromises.push(bmPermission.has(['Applications.Integra'], true));

            bmEnvironment.getEnvironmentAsync().then((env: any) => {
            });

            const _hasBrDepartmentPerm = bmPermission.has('OnvioBR.EnableBRDepartments')
                .then(() => true).catch(() => false);
            const _hasBrDepartmentAccess = bmAccess.has('BR_EnableBRDepartments')
                .then(() => true).catch(() => false);

            const _hasBrDepartment = $q.all([_hasBrDepartmentPerm, _hasBrDepartmentAccess])
            .then(([brDepartmentPerm, brDepartamentAccess,]) => {
                const hasSomeImports = brDepartmentPerm || brDepartamentAccess;
                return hasSomeImports;
            })

            const _hasWipImport = bmPermission.has('OnvioSetup.ImportWIP')
                .then(() => true).catch(() => false)
            const _hasLedgerImport = bmPermission.has('OnvioSetup.ImportLedgerItems')
                .then(() => true).catch(() => false)
            const _hasClientImport = $q.all([bmPermission.has('OnvioSetup.ImportClients'), bmAccess.not('HideClientImport')])
                .then(() => true).catch(() => false)

            const _hasSomeImports = $q.all([_hasWipImport, _hasLedgerImport, _hasClientImport])
                .then(([hasWipImport, hasLedgerImport, hasClientImport]) => {
                    const hasSomeImports = hasWipImport || hasLedgerImport || hasClientImport;
                    return hasSomeImports;
                })

            const _hasBrStaffPermissionGroup = $q.all([
                bmLicense.has('OnvioBR.PermissionsGroup').catch(() => false),
                bmAccess.has('Brazil_NewStaffPermissionDesign').catch(() => false)
            ]);

            const migrationPromises = [];
            migrationPromises.push(bmAccess.has('MigrationResults'));
            migrationPromises.push(bmPermission.hasSome(['OnvioSetup.Migrations', 'OnvioSetup.MigrateData', 'OnvioSetup.DataServices',
                'OnvioSetup.MigrationDashboard']));

            const showOldMigrationLinkPromises = [];
            showOldMigrationLinkPromises.push(bmPermission.has('OnvioSetup.Migrations'));
            showOldMigrationLinkPromises.push(bmPermission.notSome(['OnvioSetup.MigrationDashboard', 'OnvioSetup.MigrateData']));

            const timeAndExpensesPromises = [];
            timeAndExpensesPromises.push(bmPermission.has('TimeAndBilling.TimeAndExpense'));

            const billingPromises = [];
            billingPromises.push(bmPermission.hasSome(['TimeAndBilling.Billing', 'TimeAndBilling.ReviewInvoices', 'TimeAndBilling.PrintStatements', 'TimeAndBilling.LateFees', 'TimeAndBilling.FixedFeeBilling']));

            const receiptsAndAdjustmentsPromises = [];
            receiptsAndAdjustmentsPromises.push(bmPermission.has('TimeAndBilling.ReceiptAndAdjustment'));

            var hideFirmReports = bmAccess.has('HideFirmReports')
                .then((value: boolean) => this.hideFirmReportsIAC = value)
                .catch(() => angular.noop());

            bmAccess.has('HideFERebuild_ActivityCategories')
            .then(() => this.hideNewActivityCategory = true)
                .catch(() => angular.noop());

            bmAccess.has('HideFERebuild_Activities')
            .then(() => this.hideNewActivity = true)
            .catch(() => angular.noop());

            bmAccess.has('BR_HideReportEmployee')
                .then(() => this.showReportEmployee = false)
                .catch(() => angular.noop());

            var reportFirmManagementFRP = bmPermission.has('Reports.FirmManagement')
                .then((value: boolean) => this.reportsFirmManagementFRP = value)
                .catch(() => angular.noop());

            $q.all([hideFirmReports, reportFirmManagementFRP])
                .then(() => this.showFirmReports = this.reportsFirmManagementFRP && !this.hideFirmReportsIAC)
                .catch(() => angular.noop());

            $q.all(clientDashPromises)
                .then(() => { this.showClientDashboard = true; })
                .catch(() => angular.noop());

            $q.all(dueDatesPromises)
                .then(() => { this.showDueDates = true; })
                .catch(() => angular.noop());

            $q.all(firmDashPromises)
                .then(() => { this.showFirmDashboard = true; })
                .catch(() => angular.noop());
            $q.all([_hasSomeImports])
                .then(([hasPerm]) => { this.showImports = hasPerm; })
            $q.all(migrationPromises)
                .then(() => { this.showMigrations = true; })
                .catch(() => angular.noop());
            $q.all(showOldMigrationLinkPromises)
                .then(() => { this.showOldMigrationsLink = true; })
                .catch(() => angular.noop());
            $q.all(timeAndExpensesPromises)
                .then(() => { this.showTimeAndExpenses = true; })
                .catch(() => angular.noop());
            $q.all(billingPromises)
                .then(() => { this.showBilling = true; })
                .catch(() => angular.noop());
            $q.all([_hasBrDepartment])
                .then(([hasPerm]) => { this.showBRDepartments = hasPerm; })
                .catch(() => angular.noop());
            $q.all(receiptsAndAdjustmentsPromises)
                .then(() => { this.showReceiptsAndAdjustments = true; })
                .catch(() => angular.noop());
            $q.all([_hasBrStaffPermissionGroup])
                .then(([authorization]) => {
                    const [brazilStaffPermissionGroupLicense,brazilStaffPermissionGroupIAC] = authorization;
                    this.hasLicenseForBrazilStaffPermissionGroup = brazilStaffPermissionGroupLicense || brazilStaffPermissionGroupIAC;
                })
                .catch(() => angular.noop());
        }
    }

    export class StaffNavComponent {
        controller = StaffNavController;
        templateUrl = 'nav/bm-staff-nav.html';
    }

    angular.module('onvio.nav.staffNav', [
        'bluemoon.components.nav',
        'bmAccess',
        'bmPermission',
        'bmLicense'
    ])
    .component('bmStaffNav', new StaffNavComponent())
    .directive('appNavToggleState', ['$timeout', function($timeout) {
        function link($scope: any, element: JQLite) {
            const controller = new AbortController();
            const { signal } = controller;

            const nav = element.get(0);
            let observer: MutationObserver;

            function getFocusableElement(next: boolean = true) {
                const currentElement = document.activeElement;
                const focusableElements = document.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');

                let currentIndex = Array.from(focusableElements).indexOf(currentElement);

                if (currentIndex === -1) {
                    return null;
                }

                do {
                    currentIndex = (next ? (currentIndex + 1) : (currentIndex - 1)) % focusableElements.length;
                } while (!(focusableElements[currentIndex] as HTMLElement)?.offsetParent); // Skip hidden elements

                return focusableElements[currentIndex];
            }

            function getNextFocusableElement() {
                return getFocusableElement(true);
            }

            function getPreviousFocusableElement() {
                return getFocusableElement(false);
            }

            function mutationObserverCallback(mutationsList: MutationRecord[]) {
                const isNavMoreItemMenuVisible = document.querySelector('li:not(.hidden) > a.navmore-moreitem');

                for (const mutation of mutationsList) {
                    const target = mutation.target as HTMLElement;

                    //  Remove tabindex from menu when only setup tab is visible
                    //  If More... menu is visible, no need to add/remove tabindex ( navmore library is managing tabindex )
                    if (!isNavMoreItemMenuVisible && target.hasAttribute('data-is-setup-child')) {
                        if (target.classList.contains('bm-staff-nav-menu-expand')) {
                            target.setAttribute('tabindex', "-1");
                        } else if (!target.classList.contains('ng-hide')) { //  Do not touch elements which has .ng-hide class
                            target.setAttribute('tabindex', "0");
                        }
                    }
                    if (isNavMoreItemMenuVisible && target?.classList.contains('navmore-moreitem')) {
                        document.querySelectorAll('a[role="menuitem"]').forEach((el) => {
                            el.setAttribute('tabindex', '0');
                            el.setAttribute('aria-hidden', 'false');
                        });
                        document.querySelector('.navmore-moreitem').nextElementSibling.querySelectorAll('a').forEach(el => el.setAttribute('tabindex', '-1'));
                    }

                    if (target.classList.contains('selected')) {
                        target.setAttribute('aria-current', 'page');
                    } else {
                        if (target.hasAttribute('aria-current')) {
                            target.removeAttribute('aria-current');
                        }
                    }
                    if (mutation.type === 'attributes' && mutation.attributeName === 'class' &&
                        target.hasAttribute('aria-haspopup')) {
                        target.setAttribute('aria-expanded', String(target.classList.contains('focused')));
                    }
                }
            }

            function startObservingElements() {
                const anchors = nav.querySelectorAll('a');

                //  When cursor or focus moves out from the expanded menu, the parent menu should be closed automatically
                const setupMenu = document.getElementById('setup-menu');
                const menus = document.getElementById("menus");

                //  Add custom attribute to identify the menus under setup tab
                for (const target of [...Array.from(menus.querySelectorAll('a'))]) {
                    target.setAttribute('data-is-setup-child', 'true');

                    const isNavMoreItemMenuVisible = document.querySelector('li:not(.hidden) > a.navmore-moreitem');

                    //  Make links arrow accessible only where there is no "more..." link available
                    if (!isNavMoreItemMenuVisible) {
                        target.addEventListener('keydown', function(event) {
                            switch (event.key) {
                                case "ArrowDown":
                                case "ArrowRight":
                                    const nextElement = getNextFocusableElement();
                                    if (nextElement) (nextElement as HTMLElement)?.focus();
                                    break;

                                case "ArrowUp":
                                case "ArrowLeft":
                                    const previousElement = getPreviousFocusableElement();
                                    if (previousElement) (previousElement as HTMLElement)?.focus();

                                    break;
                            }
                        }, { signal } as AddEventListenerOptions);
                    }
                }

                const menusAnchors = [setupMenu, ...Array.from(menus.querySelectorAll('a'))];
                for (let targetNode of Array.from(menusAnchors)) {

                    targetNode.addEventListener('blur', e => {
                        if (!Array.from(menusAnchors).some(s => s === e.relatedTarget)) {
                            setupMenu.setAttribute('aria-expanded', 'false');
                            setupMenu.classList.remove('focused');
                            e.preventDefault();
                        }
                    });
                }

                /*
                    Because this menu items controled by external Vanilla JS script
                    (https://github.com/pinkhominid/navmore/blob/fa0ba0f873986f0be5589b322dab0b95a906aead/navmore.js#L28)
                    the only way to hook into it's logic is to listen class attribute change.
                    And since it runs its updates outside of AngularJS should be used plain DOM API.
                */
                observer = new MutationObserver(mutationObserverCallback);
                for (let targetNode of Array.from(anchors)) {
                    observer.observe(targetNode, { attributes: true, attributeFilter: ['class'] });
                }
            }
                /*
                    Because this menu items controled by external Vanilla JS script
                    (https://github.com/pinkhominid/navmore/blob/fa0ba0f873986f0be5589b322dab0b95a906aead/navmore.js#L28)
                    the only way to hook into it's logic is to listen class attribute change.
                    And since it runs its updates outside of AngularJS should be used plain DOM API.
                */
            // need to await next tick after angular render inner content
            $timeout(startObservingElements);

            $scope.$on('$destroy', function() {
                observer && observer.disconnect();
                controller.abort();
            });
        }
        return {
            link: link,
        };
    }]);
}
